/**
 * The order table every non-register deployment sees — the markup OrdersPage
 * carried before the E4 register split, moved here unchanged (SA-397, spec
 * D24: "everything else renders today's table").
 */
import { formatCurrency } from '@/utils/currency'
import { QueueCell } from '@/components/records/queueBits'
import { timeAgo } from '@/components/records/queueText'
import { StatusBadge } from './StatusBadge'
import { ClampedText } from '@/components/records/ClampedText'
import type { Order } from '@/types/commerce'

export function LegacyOrdersTable({
  orders, onSelect, assigneeNames,
}: {
  orders: Order[]
  onSelect: (order: Order) => void
  assigneeNames: Record<string, string>
}) {
  return (
    <div className="bg-card rounded-lg border border-border overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-muted text-left text-xs text-muted-foreground uppercase tracking-wider whitespace-nowrap">
            <th className="px-4 py-3">Order</th>
            <th className="px-4 py-3">Customer</th>
            <th className="px-4 py-3">Type</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Queue</th>
            <th className="px-4 py-3 text-right">Amount</th>
            <th className="px-4 py-3">Created</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {orders.map(order => (
            <tr key={order.id}
              onClick={() => onSelect(order)}
              className="hover:bg-muted cursor-pointer transition-colors">
              <td className="px-4 py-3 font-medium text-foreground whitespace-nowrap">{order.orderNumber}</td>
              <td className="px-4 py-3 min-w-[140px]">
                <p className="text-foreground"><ClampedText text={order.customerName || 'Unknown'} /></p>
                {order.customerPhone && <p className="text-xs text-muted-foreground whitespace-nowrap">{order.customerPhone}</p>}
              </td>
              <td className="px-4 py-3 text-muted-foreground capitalize whitespace-nowrap">{order.orderType}</td>
              <td className="px-4 py-3 whitespace-nowrap"><StatusBadge status={order.status} /></td>
              <td className="px-4 py-3 whitespace-nowrap">
                <QueueCell order={order} assigneeNames={assigneeNames} />
              </td>
              <td className="px-4 py-3 text-right font-medium whitespace-nowrap">{order.totalCents > 0 ? formatCurrency(order.totalCents, order.currency) : '—'}</td>
              <td className="px-4 py-3 text-muted-foreground whitespace-nowrap">{timeAgo(order.createdAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
